// extracted by mini-css-extract-plugin
module.exports = {"title":"post-preview-module--title--1wWUy","body":"post-preview-module--body--23OMd"};